import { DecimalPipe } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgSelectModule } from '@ng-select/ng-select';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { AgGridModule } from 'ag-grid-angular';
import { ToastrModule } from 'ngx-toastr';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ArrowChartComponent } from './core/charts/arrow-chart/arrow-chart.component';
import { GaugeChartComponent } from './core/charts/gauge-chart/gauge-chart.component';
import { HistoryChartComponent } from './core/charts/history-chart/history-chart.component';
import { LongThresholdChartComponent } from './core/charts/long-threshold-chart/long-threshold-chart.component';
import { ShortThresholdChartComponent } from './core/charts/short-threshold-chart/short-threshold-chart.component';
import { TimelineChartComponent } from './core/charts/timeline-chart/timeline-chart.component';
import { CpaAccountsDialog } from './core/dialogs/cpa-accounts-dialog/cpa-accounts-dialog.component';
import { AuthExpiredInterceptor } from './core/interceptors/auth-expired.interceptor';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { FormattedNumberPipe } from './core/pipes/formatted-number.pipe';
import { MomentPipe } from './core/pipes/moment.pipe';
import { TranslatePipe } from './core/pipes/translate.pipe';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DocumentsComponent } from "./documents/documents.component";
import { EventComponent } from './event/event.component';
import { LanguageSelectorComponent } from './language-selector/language-selector.component';
import { LoginComponent } from './login/login.component';
import { MailTemplateComponent } from './mail-template/mail-template.component';
import { SearchComponent } from './search/search.component';
import { ShipmentComponent } from './shipment/shipment.component';
import { TitleComponent } from './title/title.component';

@NgModule({
  declarations: [
    AppComponent,
    ArrowChartComponent,
    CpaAccountsDialog,
    DashboardComponent,
    DocumentsComponent,
    EventComponent,
    FormattedNumberPipe,
    GaugeChartComponent,
    HistoryChartComponent,
    LanguageSelectorComponent,
    LoginComponent,
    LongThresholdChartComponent,
    MailTemplateComponent,
    MomentPipe,
    SearchComponent,
    ShipmentComponent,
    ShortThresholdChartComponent,
    TimelineChartComponent,
    TitleComponent,
    TranslatePipe
  ],
  imports: [
    AgGridModule.withComponents([]),
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    EditorModule,
    FormsModule,
    HttpClientModule,
    MatDialogModule,
    NgSelectModule,
    ReactiveFormsModule,
    ToastrModule.forRoot()
  ],
  providers: [
    DecimalPipe,
    FormattedNumberPipe,
    MomentPipe,
    TranslatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthExpiredInterceptor, multi: true },
    { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
